import type { ApiFilters, Filters, FilterProps } from './types';

export function isFilterEnabled(props: Record<string, unknown>, key: string): boolean {
  return (props[key] as FilterProps | undefined)?.enabled !== false;
}

interface GetDefaultsOptions {
  assigneeId?: number | null;
  overrides?: Partial<Filters>;
}

export function getDefaults({ assigneeId = null, overrides }: GetDefaultsOptions = {}): Filters {
  return {
    assigneeId: assigneeId,
    completed: false,
    dealUserId: null,
    fromDate: null,
    officeId: null,
    open: false,
    overdue: false,
    parentType: null,
    query: '',
    sortBy: 'deadline',
    sortOrder: 'asc',
    tbd: null,
    allTasks: null,
    toDate: null,
    ...overrides,
  };
}

export function serializeFilters(filters: Filters): ApiFilters {
  const statuses: string[] = [];

  if (filters.completed) {
    statuses.push('completed');
  }

  if (filters.open) {
    statuses.push('open');
  }

  if (filters.overdue && !filters.tbd) {
    statuses.push('overdue');
  }

  const apiFilters: ApiFilters = {
    assigneeId: filters.assigneeId,
    dealUserId: filters.dealUserId,
    fromDate: filters.fromDate,
    officeId: filters.officeId,
    parentTypeFilter: filters.parentType,
    query: filters.query,
    sortBy: filters.sortBy,
    sortOrder: filters.sortOrder,
    statuses,
    tbd: filters.tbd,
    allTasks: filters.allTasks,
    toDate: filters.toDate,
  };

  return apiFilters;
}
